import * as React from "react";
import "./index.scss";
import Lottie from "lottie-react";
import loader from "@lottie/loader.json";
import loader1 from "@lottie/loader1.json";
interface INotFoundPageProps {}

const Loader: React.FunctionComponent<INotFoundPageProps> = (props) => {
	return (
		<div className="loading-wrapper d-flex w-100 my-5">
			<div className="loading-wrapper__details">
				{/* <img src="/gif/loading.gif" className="loading-image img-fluid" /> */}
				<Lottie animationData={loader} loop={true} style={{height:'330px',width:'330px'}} />
			</div>
		</div>
	);
};

export default Loader;
